import React, { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, Image, InputGroup, Modal, Placeholder, ProgressBar, Row, Spinner } from "react-bootstrap";
import StudentStatistics from "views/Admin/user-management/StudentStatistics";
import { getStudentInfo, getStudentStatsById } from "services/Student/UserInfo.services";
import ProgressBarCards from "components/shared/ProgressBarCards";
import PageHeading from "components/shared/PageHeading";
import { useNavigate, useParams } from "react-router-dom";
import UserClassAndGroups from "components/shared/UserClassAndGroups";
import placeholder from "../../../assets/schoolimage.png";
import dropdown from "../../../assets/dropdown.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faEyeSlash, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { deleteUser, resetPassword, updateUserInfo } from "services/Admin/UserManagement/School.service";
import { useTranslation } from "react-i18next";


const ClassStudentDetailPage = () => {
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [statsData, setStatsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingstats, setLoadingStats] = useState(true);
  const { studentId } = useParams();
  const [loadingModal, setLoadingModal] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);

  const [showNameModal, setShowNameModal] = useState(false);
  const [fullName, setFullName] = useState('');
  const handleOpenNameModal = () => setShowNameModal(true);
  const handleCloseNameModal = () => setShowNameModal(false);
  const handleOpenResetModal = () => setShowResetModal(true);
  const handleCloseResetModal = () => setShowResetModal(false);
  const fetchData = async () => {
    try {
      setLoading(true);
      const userResponse = await getStudentInfo(studentId);
      const userData = await userResponse.data.result;
      setUserData(userData);
      if (userData.subjectLevels?.length > 0) {
        setSelectedSubject(userData.subjectLevels[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchStats = async () => {
    try {
      setLoadingStats(true)
      const statsResponse = await getStudentStatsById(studentId);
      console.log("Stats resonse", statsResponse?.data)
      const statsData = await statsResponse?.data?.result;
      setStatsData(statsData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingStats(false);
    }
  };
  useEffect(() => {
    fetchData();
    fetchStats();
  }, []);

  const handleSubjectChange = (subject) => {
    setSelectedSubject(subject);
  };


  const stats = [
    {
      heading: t("Total Level"),
      count: userData ? userData.rank : 1,
      value: userData ? Math.floor((userData.xp / userData.threshold) * 100) : 0,
    },
    {
      heading: `Subject Level (${selectedSubject?.subject?.title})`,
      count: selectedSubject ? selectedSubject.totalLevel : 1,
      value: selectedSubject
        ? Math.floor((selectedSubject.totalXp / selectedSubject.totalThreshold) * 100)
        : 0,
    },
  ];
  const onResetClick = async () => {
    if (!password || !confirmPassword) return;
    if (password?.length < 8 || password?.length > 20) {
      setError("Password must be minimum 8 characters & maximum 20 characters")
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoadingModal(true);
    try {
      await resetPassword(password, userData?._id); // Call API function
      setShowToast(true); // Show success toaster
      // setTimeout(() => {
      //     setShowToast(false);
      //     handleClose(); // Close modal after success
      // }, 2000);
      setShowResetModal(false);
      setPassword("");
      setConfirmPassword("");
      toast.success("Reset password successfully!", { autoClose: 2000 });
      // handleClose();
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Error Reseting the password.");
      setError("Failed to reset password. Try again.");
    } finally {
      setLoadingModal(false);
    }
  };
  const onSaveClick = async () => {
    if (!fullName) {
      setError("Full Name is required");
      return;
    }
    setLoadingModal(true);
    try {
      // Call API function to update user info with fullName
      await updateUserInfo(fullName, userData?._id); // Assuming updateUserInfo accepts fullName and userId
      setFullName(""); // Clear the input after successful update
      setShowNameModal(false);
      fetchData();
      toast.success("User info updated successfully!", { autoClose: 2000 });
    } catch (error) {
      console.error("Error updating user info:", error);
      toast.error("Error updating user info.");
      setError("Failed to update user info. Try again.");
    } finally {
      setLoadingModal(false);
    }
  };
  const handleDelete = async () => {
    const toastId = toast.loading("Deleting Student...");
    try {
      await deleteUser(userData?._id);
      toast.update(toastId, {
        render: "Student deleted successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
      navigate(`/users/students`);
    } catch (error) {
      toast.update(toastId, {
        render: "Error deleting Student",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
  };
  const dicebearUrl = `https://api.dicebear.com/9.x/initials/svg?seed=${userData?.fullName}`;

  return (
    <>
      <Row>
        {/* Subject and Skill Dropdowns */}
        <Col
          xs={12}
          className="mb-3 d-flex flex-row align-items-center justify-content-end"
        >
          <Dropdown
            onSelect={(eventKey) =>
              handleSubjectChange(userData?.subjectLevels[eventKey])
            }
          >
            <Dropdown.Toggle className="px-3 button-style border-0">
              {selectedSubject && selectedSubject.subject.title
                ? `Subject: ${selectedSubject.subject.title}`
                : "Select Language"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {userData &&
                userData.subjectLevels?.map((subject, index) => (
                  <Dropdown.Item eventKey={index} key={subject.subject._id}>
                    {subject.subject.title}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>

        {/* User Welcome Section with Placeholder */}
        {loading ? (
          [...Array(4)].map((_, index) => (
            <Col xs={12} xl={3} md={6} style={{ color: "#303972" }} key={index}>
              <div
                style={{ minHeight: "140px" }}
                className="my-3 school-cards px-4 py-4 pb-3 border-0 text-decoration-none rounded-3 shadow-lg"
              >
                <Placeholder animation="glow" className="gap-2">
                  <Placeholder xs={3} size="lg" />{" "}
                  <Placeholder xs={9} size="lg" />
                  <Placeholder xs={12} size="lg" />
                </Placeholder>
              </div>
            </Col>
          ))
        ) : (
          <Col xs={12} xl={4} md={6} style={{ color: "#303972" }}>
            <div
              style={{ minHeight: "140px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 14px 0px" }}
              className="my-3  px-4 py-4 pb-3 border-0 text-decoration-none rounded-3 d-flex flex-row align-items-center gap-3 position-relative"
            >
              <div style={{ position: 'absolute', right: '10px', top: '10px' }}>
                <Dropdown>
                  <Dropdown.Toggle
                    className="more bg-transparent text-black border-0 e-caret-hide rounded-0"
                    id="dropdown-basic"
                  >
                    <Card.Img
                      style={{ width: "24px", height: "24px" }}
                      variant="top"
                      src={dropdown}
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="border-0"
                    style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}
                  >
                    <Dropdown.Item
                      onClick={handleOpenResetModal}
                    // as={Link} to={`edit-school/${id}`}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      {t("Reset Password")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={handleOpenNameModal}
                    // as={Link} to={`edit-school/${id}`}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      {t("Edit Name")}
                    </Dropdown.Item>
                    <Dropdown.Item className="text-danger"
                      onClick={handleDelete}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      {t("Delete")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div
                style={{
                  borderRadius: "70%",
                  overflow: "hidden",
                  minWidth: "90px",
                  minHeight: "90px",
                  maxWidth: "90px",
                  background: "#F6F6F6",
                  border: "5px solid #E15455",
                }}
              >
                <Image
                  width={"100%"}
                  height={"100%"}
                  // src={userData?.avatar?.imageUrl?.url}
                  src={userData?.avatar?.imageUrl?.url ? userData?.avatar?.imageUrl?.url : userData?.fullName ? dicebearUrl : placeholder}
                />
              </div>
              <div
                className="d-flex align-items-center flex-column mx-auto text-center"
                style={{ color: "#5e5e5e" }}
              >
                <h4 style={{ fontWeight: "700" }}>{userData?.fullName}</h4>
                <span style={{ fontWeight: "400", fontSize: "0.8rem" }}>{userData?.email}</span>
              </div>
            </div>
          </Col>
        )}

        {/* Progress Cards with Placeholder */}
        {!loading &&
          stats.map((stat, index) => (
            <Col xs={12} xl={4} md={6} key={index}>
              <ProgressBarCards
                value={stat.value}
                heading={stat.heading}
                count={stat.count}
              />
            </Col>
          ))}
        {selectedSubject &&
          !loading &&
          selectedSubject.skillLevels?.length > 0 && (
            <Col xs={12}>
              <Card className="my-3 border-0 shadow-lg">
                <Card.Body>
                  <Card.Title>{t("Skills Progress")}</Card.Title>
                  {selectedSubject.skillLevels.map((skill, index) => (
                    <div key={index} className="mb-3">
                      <div className="d-flex justify-content-between">
                        <span>
                          {String(skill.skillName).charAt(0).toUpperCase() +
                            String(skill.skillName).slice(1)}
                        </span>
                        <span style={{ color: "#5e5e5e" }}>
                          Level {skill.level}
                        </span>
                      </div>
                      <ProgressBar
                        now={(skill.xp / skill.threshold) * 100}
                        variant="success"
                        animated
                        label={`${Math.floor(
                          (skill.xp / skill.threshold) * 100
                        )}%`}
                      />
                    </div>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          )}
      </Row>

      {/* Statistics Section with Placeholder */}
      <div>
        <Card className="py-3 mt-3 border-0">
          {loadingstats ? (
            <>
              <Placeholder animation="glow" className="mb-3">
                <Placeholder lg={2} />
              </Placeholder>
              <Placeholder as="div" animation="glow">
                <Placeholder xs={12} />
                <Placeholder xs={9} />
                <Placeholder xs={5} />
              </Placeholder>
            </>
          ) : (
            <>
              <PageHeading heading="Statistics" spanText='(Last 30 Days)' />
              {/* <span className="pt-2 mb-0 me-2">(Last 30 Days)</span> */}
              <StudentStatistics statsData={statsData} className="mt-2" />
            </>
          )}
        </Card>
      </div>
      <UserClassAndGroups classes={userData?.class} groups={userData?.groups} isLoading={loading} />
      <Modal show={showResetModal} onHide={handleCloseResetModal} centered size={"lg"}>
        <Modal.Header closeButton className='border-0'>
          <Modal.Title>{t("Reset")} {userData?.fullName} {t("Password")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Password Input */}
          <Form.Group>
            <Form.Label>{t("New Password")}</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder={t('Enter new password')}
                className='px-3 py-2 border-right-0'
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(""); // Clear error on input change
                }}
              />
              <InputGroup.Text style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          {/* Confirm Password Input */}
          <Form.Group className="mt-3">
            <Form.Label>{t("Confirm Password")}</Form.Label>
            <InputGroup>
              <Form.Control
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder={t('Confirm new password')}
                className='px-3 py-2 border-right-0'
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setError(""); // Clear error on input change
                }}
              />
              <InputGroup.Text style={{ cursor: 'pointer' }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
              </InputGroup.Text>
            </InputGroup>
            {error && <small className="text-danger mt-1">{error}</small>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className='border-0 justify-content-between'>
          <Button variant="secondary" className='mt-1 px-4 button-style py-2 border-0' style={{ background: "linear-gradient(270deg, #272727 0%, #4B4B4B 100%)" }} onClick={handleCloseResetModal} disabled={loadingModal}>
            {t("Cancel")}
          </Button>
          <Button variant="primary" className='mt-1 px-4 button-style py-2 border-0' onClick={onResetClick} disabled={!password || !confirmPassword || loadingModal}>
            {loadingModal ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : t("Reset")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showNameModal} onHide={handleCloseNameModal} centered size={"lg"}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>{t("Edit")} {userData?.fullName} {t("Info")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Full Name Input */}
          <Form.Group>
            <Form.Label>{t("Full Name")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("Enter new full name")}
              className="px-3 py-2"
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
                setError(""); // Clear error on input change
              }}
            />
            {error && <small className="text-danger mt-1">{error}</small>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <Button
            variant="secondary"
            className="mt-1 px-4 button-style py-2 border-0"
            style={{ background: "linear-gradient(270deg, #272727 0%, #4B4B4B 100%)" }}
            onClick={handleCloseNameModal}
            disabled={loadingModal}
          >
            {t("Cancel")}
          </Button>
          <Button
            variant="primary"
            className="mt-1 px-4 button-style py-2 border-0"
            onClick={onSaveClick}
            disabled={!fullName || loadingModal}
          >
            {loadingModal ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : t("Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ClassStudentDetailPage;
